/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('main.cases.authorizationForm', {
      url: '/:id/authorizationForm',
      template: '<authorization-form case="$resolve.case"></authorization-form>',
      resolve: {
        /* @ngInject */
        case: ($http, $stateParams) => $http
          .get(`/case/${$stateParams.id}`, { params: { caseResponse: true } })
          .then(({ data }) => data),
      },
    });
}



// WEBPACK FOOTER //
// ./client/app/cases/authorization-form/authorization-form.routes.js